export enum GridCellFormatterType {
  ColorScheme = 'ColorSchemeCellFormatter',
  ColorNumber = 'ColorNumberCellFormatter',
  Link = 'LinkCellFormatter',
  Favourite = 'FavoriteCellFormatter',
  FileActions = 'FileActionsCellFormatter',
  Custom = 'CustomCellFormatter',
  Container = 'ContainerCellFormatter',
}
